export interface BrushSize {
  readonly id: string
  readonly label: string
  readonly px: number
}

export const BRUSH_SIZES: readonly BrushSize[] = [
  { id: 'small', label: 'Small', px: 10 },
  { id: 'medium', label: 'Medium', px: 24 },
  { id: 'fat', label: 'Fat', px: 48 },
] as const

export const DEFAULT_BRUSH_SIZE: BrushSize = BRUSH_SIZES[1]
